import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectGuard } from './common/auth/redirect.guard';
import { AuthLayoutComponent } from './components/auth-layout/auth-layout.component';
import { SignUpTargets } from './enums/sign-up-targets.enum';
import { TrackingResolver } from './components/shared/tracking.resolver';

const routes: Routes = [
    // root navigation will route to login
    { path: '', pathMatch: 'full', redirectTo: 'auth/login' },

    {
        path: 'sign-up',
        component: AuthLayoutComponent,
        children: [
            {
                path: '',
                loadComponent: () => import('./components/auth-layout/sign-up/sign-up.component').then(m => m.SignUpComponent),
            },
            /** Targeted Roles for Signup */
            {
                path: SignUpTargets.HOMEOWNER,
                loadComponent: () => import('./components/auth-layout/sign-up/homeowner-sign-up/homeowner-sign-up.component').then(m => m.HomeownerSignUpComponent),
            },
            {
                path: SignUpTargets.HOMEOWNER + '/:org_url',
                loadComponent: () => import('./components/auth-layout/sign-up/homeowner-sign-up/homeowner-sign-up.component').then(m => m.HomeownerSignUpComponent),
            },
            {
                path: SignUpTargets.BOARD_MEMBER,
                loadComponent: () => import('./components/auth-layout/sign-up/board-sign-up/board-sign-up.component').then(m => m.BoardSignUpComponent),
            },
            {
                path: SignUpTargets.PROPERTY_MANAGER,
                loadComponent: () => import('./components/auth-layout/sign-up/pmc-sign-up/pmc-sign-up.component').then(m => m.PmcSignUpComponent),
            },
            /** Branded Organization for Signup */
            {
                path: ':org_url',
                loadComponent: () => import('./components/auth-layout/login/branded-login/branded-login.component').then(m => m.BrandedLoginComponent),
            },
        ],
        resolve: {
            tracking: TrackingResolver,
        },
    },

    // legacy join/* redirects to sign-up
    {path: 'join', redirectTo: '/sign-up', pathMatch: 'full'},
    {path: 'join/:org_url', redirectTo: '/sign-up/:org_url', pathMatch: 'full'},

    {
        path: 'auth',
        loadChildren: () => import('./components/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule),
    },
    // V2 Layout routes for /app (must come BEFORE general /app route for proper matching)
    {
        path: 'app',
        loadChildren: () => import('./components/v2-layout/v2-layout.module.app').then(m => m.V2LayoutModuleApp),
    },
    // Traditional app-layout routes (catch-all for /app/*)
    {
        path: 'app',
        loadChildren: () => import('./components/app-layout/app-layout.module.payhoa').then(m => m.AppLayoutModulePayhoa),
    },
    {
        path: 'events',
        loadChildren: () => import('./components/app-layout/app-layout.module').then(m => m.AppLayoutModule),
    },
    {
        path: 'admin',
        loadChildren: () => import('./components/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
    },
    {
        path: 'pmc',
        loadChildren: () => import('./components/v2-layout/v2-layout.module.pmc').then(m => m.V2LayoutModulePmc),
    },
    {
        path: 'redirect',
        loadComponent: () => import('./components/redirect/redirect.component').then(m => m.RedirectComponent),
    },
    {
        path: 'error', loadComponent: () => import('./components/error/error.component').then(m => m.ErrorComponent),
    },

    // marketing redirects
    { path: 'community-association-management-software', redirectTo: 'hoa-management-software' },
    { path: 'condo-management-software', redirectTo: 'hoa-management-software' },
    { path: 'hoa-coa-association-management-software-app', redirectTo: 'hoa-management-software' },
    { path: 'hoa-management-software-landing', redirectTo: 'hoa-management-software' },
    { path: 'hoa-management-software-screens', redirectTo: 'hoa-management-software' },
    {
        path: 'hoa-management-software',
        canActivate: [RedirectGuard],
        component: RedirectGuard,
        data: {
            externalUrl: 'https://www.payhoa.com/hoa-software-landing/',
        }
    },

    // catch any unmatched routes and redirect to the error path
    { path: '**', redirectTo: 'error' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule
{ }
